<template>
    <div class="">
       <!-- IMPRESION TICKET DE COMPRA -->
       <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        :filename="`Labels-Order`"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="100%"
        ref="reporte"
      >
        <section slot="pdf-content">
          <section class="pdf-item">
            <div class="printCompra">
              <div class="container">
                <div class="row mt-5">
                  <div class="col-lg-12">
                    FOLIO: {{ compra.id_buy }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-12">
                    Fecha de compra: {{ compra.date }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6">
                    Tienda: {{compra.name}}
                  </div>
                  <div class="col-lg-6">
                    Usuario que registro: {{ compra.user_name }}
                  </div>
                </div>
                <div class="row justify-content-center mt-3">
                  Total de compra: $ {{ compra.amount | formatNumberCurrency }}
                </div>
                <div class="row justify-content-center mt-5">
                  <div class="title">Relación de productos</div>
                </div>
                <div class="mt-3">
                  <table>
                    <colgroup span="4" class="columns"></colgroup>
                    <tr class="text-center">
                      <th>Codigo de barras</th>
                      <th>Cantidad</th>
                      <th>Producto</th>
                      <th>Precio Cliente</th>
                      <th>Descuento</th>
                      <th>Costo Cliente</th>
                      <th>Costo Tienda</th>
                    </tr>
                    <tr v-for="item in items" :key="item.id_order">
                      <td>{{ item.barcode }}</td>
                      <td>{{ item.cantidad }}</td>
                      <td>{{ item.marca + '-' + item.modelo + '-' + item.color + '-' + item.numero }}</td>
                      <td>$ {{ item.precio | formatNumberCurrency}}</td>
                      <td>$ {{ item.descuento | formatNumberCurrency}}</td>
                      <td>$ {{ item.venta | formatNumberCurrency}}</td>
                      <td>$ {{ item.costo_tienda | formatNumberCurrency}}</td>
                    </tr>
                    <tr>
                      <td colspan="5" class="text-right">Total:  </td>
                      <td>$ {{ compra.amount | formatNumberCurrency }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </section>
      </vue-html2pdf>
     </div>
</template>
<script>
import VueHtml2pdf from 'vue-html2pdf'
import { mapGetters } from 'vuex'
import moment from 'moment-timezone'
import axiosAdelaService from '@/axios/axiosAdelaService'
moment().tz('America/Mexico_city').format()

export default {
  props: ['ticket', 'enterprise', 'print'],
  components: {
    VueHtml2pdf
  },
  data () {
    return {
      compra: null,
      items: []
    }
  },
  watch: {
    print () {
      this.getDetailBuy(this.ticket)
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    }),
    horaActual () {
      return moment.utc().format('HH:mm:ss')
    }
  },
  methods: {
    async getDetailBuy (ticket) {
      try {
        const request = {
          enterprise_id: this.user.enterprise_id,
          id_buy: ticket
        }
        // console.log('request getDetailBuy', request)
        const orders = await axiosAdelaService.post('/getDetailBuy', request)
        console.log('* * * ***** getDetailBuy', orders)
        if (orders.status === 200) {
          // console.log(orders)
          this.compra = orders.data.rows
          this.compra.date = moment(this.compra.date).format('YYYY-MM-DD')
          this.items = orders.data.rows.orders
          console.log(this.$refs.reporte)
          this.$refs.reporte.generatePdf()
        }
      } catch (error) {
        console.log('error getDetailBuy', error)
        this.showError('No se pudieron obtener los datos intentalo mas tarde.')
      }
    }
  }
}
</script>

<style>

</style>
